<template lang="pug">
    div.vibe
        v-container( fluid )
            v-row
                v-col( cols="12" lg="2" md="2" sm="1" align="left" )
                    //- banner-wide-skyscraper
                v-col( cols="12" lg="8" md="8" sm="10" align="center" )
                    //- h1 Vibe
                    vibe
                v-col( cols="12" lg="2" md="2" sm="1" align="right" )
                    //- .d-none.d-md-block
                    //- banner-wide-skyscraper
</template>

<script>
    import BannerWideSkyscraper from '@/components/BannerWideSkyscraper';
    import BannerLeaderboard from '@/components/BannerLeaderboard';
    import Vibe from "@/components/Vibe.vue";

    export default {
        name: "something",
        components: {
            Vibe,
            BannerWideSkyscraper,
            BannerLeaderboard
        },
        data() {
            return {
                dialog: false
            }
        }
    };
</script>

<style scoped lang="scss">


    .vibe {
        max-width: 1185px;
        margin: 0 auto;
    }
</style>